import React, { Component, Fragment } from 'react';
import { Field } from 'redux-form';
import {
  Button,
  Form,
  Grid,
  Accordion,
  Icon,
  Divider,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import ReactTable from 'Common/ReactTableWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { DatePickerField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { AdjustmentEnum } from 'Common/FieldEnum';
import { ADJUSTMENT_LIST_FORM_NAME } from 'Common/FormEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { DatePickerCustomButton } from 'Components';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { SiteComponent } from 'Common/SiteComponent';

class AdjustmentListComponent extends Component {
  static propTypes = {
    columns: PropTypes.array.isRequired,
    adjustmentListData: PropTypes.array.isRequired,
    setSelectedSite: PropTypes.func,
    onChangeOfFromDT: PropTypes.func,
    onChangeOfToDT: PropTypes.func,
    clearFilters: PropTypes.func,
    printAdjustment: PropTypes.func,
    fromDateMax: PropTypes.object,
    toDateMin: PropTypes.object,
    printOptionsValue: PropTypes.string,
    gridPreferenceSubmitting: PropTypes.bool,
    gridPreferenceLoading: PropTypes.bool,
    loading: PropTypes.bool,
    fetchingSites: PropTypes.bool,
    printLoading: PropTypes.bool,
    reactTableRef: PropTypes.object,
  };
  static defaultProps = {
    setSelectedSite: () => {},
    onChangeOfFromDT: () => {},
    onChangeOfToDT: () => {},
    clearFilters: () => {},
    printAdjustment: () => {},
    fromDateMax: null,
    toDateMin: null,
    printOptionsValue: AdjustmentEnum.ItemCode,
    gridPreferenceSubmitting: false,
    gridPreferenceLoading: false,
    loading: false,
    fetchingSites: false,
    printLoading: false,
    reactTableRef: null,
  };
  state = {
    activeIndexForFilter: 0,
    activeIndexForSort: 0,
  };
  handleClick = (e, titleProps) => {
    const { index, option } = titleProps;
    const { activeIndexForFilter, activeIndexForSort } = this.state;
    const newIndex = !option
      ? activeIndexForFilter === index
        ? -1
        : index
      : activeIndexForSort === index
        ? -1
        : index;
    !option
      ? this.setState({
          activeIndexForFilter: newIndex,
        })
      : this.setState({
          activeIndexForSort: newIndex,
        });
  };

  render() {
    const printOptions = [
      { value: AdjustmentEnum.ItemCode, label: 'Item Id' },
      { value: AdjustmentEnum.ItemDescription, label: 'Item Description' },
    ];

    const {
      columns,
      setSelectedSite,
      fromDateMax,
      toDateMin,
      onChangeOfFromDT,
      onChangeOfToDT,
      clearFilters,
      adjustmentListData,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      fetchingSites,
      loading,
      printAdjustment,
      reactTableRef,
    } = this.props;

    return (
      <Fragment>
        <Form>
          <Accordion fluid styled>
            <Accordion.Title
              active={!this.state.activeIndexForFilter}
              index={0}
              option={0}
              onClick={this.handleClick}
            >
              <Icon name="dropdown" />
              <span className="text-orange">Filter By</span>
            </Accordion.Title>
            <Accordion.Content active={!this.state.activeIndexForFilter}>
              <Grid className="grid-spacing">
                <Grid.Row columns={4}>
                  <Grid.Column>
                    <Field
                      component={DatePickerField}
                      label={'From:'}
                      dateFormat={DATE_FORMAT_FOR_UI}
                      name={AdjustmentEnum.BeginDT}
                      onChange={onChangeOfFromDT}
                      maxDate={fromDateMax}
                      type={'text'}
                      dropdownMode="select"
                      customInput={<DatePickerCustomButton />}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Field
                      component={DatePickerField}
                      label={'To:'}
                      dateFormat={DATE_FORMAT_FOR_UI}
                      name={AdjustmentEnum.EndDT}
                      type={'text'}
                      onChange={onChangeOfToDT}
                      minDate={toDateMin}
                      customInput={<DatePickerCustomButton />}
                      dropdownMode="select"
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <SiteComponent
                      name={AdjustmentEnum.Site}
                      isForm={true}
                      label={'Site'}
                      isAllRequired={true}
                      showAllActiveSites={true}
                      onChange={setSelectedSite}
                      isAllValueZero={true}
                    />
                  </Grid.Column>
                  <Grid.Column
                    verticalAlign={'bottom'}
                    floated={'right'}
                    textAlign={'right'}
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <Button
                      content="Clear Filters"
                      onClick={clearFilters}
                      type={'button'}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Accordion.Content>

            <Accordion.Title
              active={!this.state.activeIndexForSort}
              index={0}
              option={1}
              onClick={this.handleClick}
            >
              <Icon name="dropdown" />
              <span className="text-orange">Sort By</span>
            </Accordion.Title>
            <Accordion.Content active={!this.state.activeIndexForSort}>
              <Grid>
                <Grid.Row columns={2} className={'pt10'}>
                  <Grid.Column verticalAlign={'bottom'}>
                    <ReduxFormButtonGroup
                      options={printOptions}
                      formName={ADJUSTMENT_LIST_FORM_NAME}
                      fieldName={AdjustmentEnum.PrintOptions}
                      type={'button'}
                    />
                  </Grid.Column>
                  <Grid.Column
                    floated={'right'}
                    textAlign={'right'}
                    verticalAlign={'top'}
                  >
                    <Button
                      disabled={loading}
                      content="Print"
                      type={'button'}
                      onClick={printAdjustment}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Accordion.Content>
          </Accordion>
          <Divider horizontal />
          <Grid>
            <Grid.Row columns={1} className={'remove-spacing'}>
              <Grid.Column>
                <ReactTable
                  reactTableRef={reactTableRef}
                  defaultPageSize={20}
                  showPageSizeOptions={true}
                  minRows={0}
                  data={adjustmentListData}
                  noDatatext={'No rows found'}
                  resizable={false}
                  className="-striped -highlight modalGrid"
                  columns={columns}
                  loading={
                    loading ||
                    fetchingSites ||
                    gridPreferenceLoading ||
                    gridPreferenceSubmitting
                  }
                  draggableColumns={true}
                  showHideColumn={true}
                  menu={'hasCogs'}
                  saveState={{
                    tableName: TableNamesEnum.ADJUSTMENT_LIST_TABLE,
                  }}
                  hasSelectAllColumn={true}
                  gridName={GridEnum.INV_AdjustmentList_View}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}
export default AdjustmentListComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/components/adjustmentList/AdjustmentListComponent.js